import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';

interface ConfirmActionOptions {
    /** La decisión como pregunta: "¿Eliminar feriado?", "¿Cerrar liquidación?". */
    header: string;
    /** La consecuencia, nombrando lo que se toca como lo reconoce el usuario. */
    message: string;
    /** Verbo que dice qué pasa ("Eliminar", "Quitar", "Cerrar liquidación"); nunca "Aceptar". */
    acceptLabel: string;
    onAccept: () => void;
}

/**
 * Modal de decisión (design system §3.8.3): "Cancelar" (texto, con el foco inicial) y la acción con su verbo
 * (el primario de siempre, nunca rojo). Esc y ✕ equivalen a Cancelar. La vista tiene que tener un
 * <ConfirmDialog /> montado. No se usa dentro de un Dialog o Sidebar: ahí la confirmación va inline.
 */
export function confirmAction({ header, message, acceptLabel, onAccept }: ConfirmActionOptions) {
    confirmDialog({
        header,
        message,
        className: 'md-dialog',
        style: { width: '420px' },
        breakpoints: { '640px': '100vw' },
        footer: ({ accept, reject }) => (
            <div className="md-dialog__footer">
                {/* PrimeReact 9 no tiene defaultFocus: el foco en la opción segura va con autoFocus */}
                <Button text className="md-text" label="Cancelar" onClick={reject} autoFocus />
                <Button className="md-primary" label={acceptLabel} onClick={accept} />
            </div>
        ),
        accept: onAccept,
    });
}

interface ConfirmDeleteOptions {
    header: string;
    message: string;
    onAccept: () => void;
    /** "Eliminar" por defecto; "Quitar" cuando el ítem sale de algo y vuelve a otro lado. */
    acceptLabel?: string;
}

/** Diálogo para eliminar o quitar un registro ya guardado (design system §3.7 "Eliminar"). */
export function confirmDelete({ header, message, onAccept, acceptLabel = 'Eliminar' }: ConfirmDeleteOptions) {
    confirmAction({ header, message, onAccept, acceptLabel });
}
